import { getPhoneNumberFromShortCodeFormat } from '../../../utilities/miscFunctions';
import { Customer } from '../customer/Customer';
import { IUser, User } from '../User';

export class Branch {
  id: string;
  country: string;
  city: string;
  region: string;
  code: string;
  createdAt: Date;
  updatedAt: Date;
  customer: Customer | undefined;
  address: string;
  name: string;
  manager: User | null;
  phone: string;
  email: string;
  branch_manager_user_id: string;
  users: User[];

  constructor(IModel: IBranch) {
    this.id = IModel.id;
    this.name = IModel.name;
    this.country = IModel.country;
    this.region = IModel.region;
    this.city = IModel.city;
    this.createdAt = new Date(IModel.created_at);
    this.updatedAt = new Date(IModel.updated_at);
    this.address = IModel.address;
    this.code = IModel.code;
    this.manager = IModel.manager ? new User(IModel.manager) : null;
    this.phone = getPhoneNumberFromShortCodeFormat(IModel.phone);
    this.email = IModel.email;
    this.branch_manager_user_id = IModel.branch_manager_user_id;
    this.users = IModel.users?.map((user: IUser) => new User(user)) ?? []
  }
}

export interface IBranch {
  id: string;
  name: string;
  country: string;
  region: string;
  city: string;
  address: string;
  code: string;
  created_at: string;
  updated_at: string;
  manager?: IUser;
  phone: string;
  email: string;
  branch_manager_user_id: string;
  users: IUser[];
}